import React from "react";
import styles from "./OpeningText.module.scss";
import {
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "../SectionTitle/SectionTitle";
import clsx from "clsx";

export const OpeningTextBody: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return (
    <SectionTitleBody className={styles.body}>{children}</SectionTitleBody>
  );
};

export const OpeningTextHeading: React.FC<React.PropsWithChildren<unknown>> = ({
  children
}) => {
  return (
    <SectionTitleHeading className={styles.heading} priority={1}>
      {children}
    </SectionTitleHeading>
  );
};

export const OpeningTextSubHeading: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return <h3 className={styles.subHeading}>{children}</h3>;
};

export const OpeningText: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className = undefined }) => {
  return (
    <SectionTitle
      variant="wide"
      className={clsx(styles.openingText, className)}
      data-content-name="opening_text"
    >
      {children}
    </SectionTitle>
  );
};
